import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "antd";

const getUserNamePasswordFormList = (key, userRole) => (
    <Form.List name={key}>
        {(fields, { add, remove }) => {
            return (
                <>
                    {fields.map((field, index) => (
                        <Form.Item
                            key={field.key}
                            style={{
                                margin: 0,
                                justifyContent: "end",
                            }}
                            required
                        >
                            <Row>
                                <Col xs={20}>
                                    <Form.Item
                                        name={[field.name, "email"]}
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (
                                                        !value ||
                                                        getFieldValue(key).some(
                                                            (d) =>
                                                                d === undefined,
                                                        )
                                                    ) {
                                                        return Promise.reject(
                                                            new Error(
                                                                "Few email fields are blank, remove them.",
                                                            ),
                                                        );
                                                    } else if (
                                                        !value ||
                                                        getFieldValue(
                                                            key,
                                                        ).filter(
                                                            (d) =>
                                                                d.email ===
                                                                value,
                                                        ).length !== 1
                                                    ) {
                                                        return Promise.reject(
                                                            new Error(
                                                                "Duplicate values are not allowed.",
                                                            ),
                                                        );
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            placeholder="User Name"
                                        />
                                    </Form.Item>
                                    {(userRole == "Admin" ||
                                        userRole == "Super Admin" ||
                                        userRole == "Support") && (
                                        <Form.Item
                                            name={[field.name, "password"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Password is required.",
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Password" />
                                        </Form.Item>
                                    )}
                                </Col>
                                <Col xs={4}>
                                    {fields.length > 1 && (
                                        <MinusCircleOutlined
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Form.Item>
                    ))}
                    <Form.Item>
                        <Button onClick={() => add()}>Add</Button>
                    </Form.Item>
                </>
            );
        }}
    </Form.List>
);

export { getUserNamePasswordFormList };
